import $api from "../http";
import { AxiosResponse } from "axios";
import { IStationDiagTable } from "../models/IUser";

/**
 * `п. 3` резерва (`ПИВ_07` 0.35, разд. 1; `FW-161`): диагностика станций модуля.
 *
 * Чтение журнала, не своя таблица: сервер отдаёт по каждой станции последний
 * кадр `station_diag` — причина остановки словами, сбросы с включения, время
 * работы, отказы контактора, потери связи.
 */
export default class StationDiagService {
  static fetchForModule(
    moduleId: number,
  ): Promise<AxiosResponse<IStationDiagTable>> {
    return $api.get<IStationDiagTable>(`/module/${moduleId}/station-diag`);
  }
}
